module.exports = __webpack_public_path__ + "img/1584657633099554530.9f29996c.png";